//
// Copyright 2025 DXOS.org
//

// @import-as-namespace

import { ActivationEvents, Capabilities } from '../common/index.ts';
import { Capability, Plugin } from '../core/index.ts';
import { meta } from './meta.ts';

export { meta };
export { layerIdb as storageLayer } from './idb-key-value-store.ts';

const ProcessManagerCapability = Capability.lazyModule(
  'ProcessManager',
  {
    // Event-mode on Startup: the body snapshots multi capabilities (LayerSpec, TraceSink,
    // OperationHandler), so it must run after the full registry is in — the Startup wave
    // fires post-registration and pulls all inactive multi providers first. A streaming
    // dependency round could otherwise run it before later plugins' specs contribute.
    activatesOn: ActivationEvents.Startup,
    requires: [
      Capabilities.AtomRegistry,
      Capabilities.LayerSpec,
      Capabilities.TraceSink,
      Capabilities.OperationHandler,
      Capabilities.RemoteTraceMonitor,
    ],
    provides: [
      Capabilities.ProcessManagerRuntime,
      Capabilities.ServiceResolver,
      Capabilities.ProcessManager,
      Capabilities.OperationInvoker,
      Capabilities.OperationHandlers,
    ],
  },
  () => import('./process-manager-capability.ts'),
);

const HistoryCapabilities = Capability.lazyModule(
  'HistoryCapabilities',
  {
    requires: [Capabilities.UndoMapping, Capabilities.OperationInvoker],
    provides: [Capabilities.UndoRegistry, Capabilities.HistoryTracker],
  },
  () => import('./history/capability.ts'),
);

export const make = Plugin.define(meta).pipe(
  Plugin.addModule(ProcessManagerCapability),
  Plugin.addModule(HistoryCapabilities),
  Plugin.make,
);
